import { useState, useRef } from "react";
import ArrowSlider from "~/assets/icons/ArrowSlider";
import { getCurrencyValue } from "~/lib/utils";
import { isNonTransactional, showPriceshowPriceTransactional } from "../../../../setup/settings/__nonTransactional";
import GlobalSlider from "~/rs-components/widgets/GlobalSlider.client";
import { availabilityOptionsOnCard } from "../../../../setup/settings/__product";
import FabricType from "~/assets/icons/FabricType";
import LeatherType from "~/assets/icons/LeatherType";

export default function FeaturedProductSlider({ collection, currency, cardOption }) {

    if (!collection) return <></>

    const { Products } = collection;

    const defaultSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,

        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
            {
                breakpoint: 885,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    };

    return (
        <section className={`featuredProductsSlider ${isNonTransactional ? "isNonTransactional" : ""}`}>
            <div className={`featuredProductsSlider__container ${cardOption == 1 && 'stretch'} relative m-auto p-6 text-center collectionsSlider`}>
                <h1 className="p-2 text-2xl font-bold">{collection.Title ? collection.Title : 'Exclusive online products'}</h1>
                <a href={`/collections/${collection.Handle}`} className="font-light underline decoration-1 tracking-widest text-sm">VIEW ALL</a>

                <GlobalSlider settings={defaultSettings} >

                    {Products.map((p, i) => <>
                        {cardOption == 0 && <ProductCardSquare product={p} currency={currency} />}
                        {cardOption == 1 && <ProductCardPortrait product={p} currency={currency} />}
                    </>)}
                </GlobalSlider >
            </div>
        </section>
    )
}

const ProductCardSquare = ({ product, currency }) => {
    return (
        <a href={`products/${product.handle}`} className="link flex-none itemSlider">
            <div className="image mb-4">
                <img width={325} src={product.images[0]} />
            </div>
            <p className="featuredProductsSlider__title">{product.title}</p>
            {(availabilityOptionsOnCard.typeOfMaterialEnabled || availabilityOptionsOnCard.optionsCarouselEnabled) && (
                <div className="FeaturedProduct__available-options">
                    {availabilityOptionsOnCard.typeOfMaterialEnabled && (
                        <div className="material-options">
                            {product.customfields.infabric === 'Yes' && <FabricType />}
                            {product.customfields.inleather === 'Yes' && <LeatherType />}
                            {product.customfields.inleather === 'Yes' && product.customfields.infabric === 'No' && (
                                <p>Available in Leather</p>
                            )}
                            {product.customfields.inleather === 'No' && product.customfields.infabric === 'Yes' && (
                                <p>Available in Fabric</p>
                            )}
                            {product.customfields.inleather === 'Yes' && product.customfields.infabric === 'Yes' && (
                                <p>Available in Leather and Fabric</p>
                            )}
                        </div>
                    )}
                    {availabilityOptionsOnCard.optionsCarouselEnabled && product.optionsPreviewImages && product.optionsPreviewImages.length > 0 && (
                        <div className="image-container">
                            {product.optionsPreviewImages.map((image, index) => (
                                <img className="ProductList__options-image" key={index} src={image} alt={`Option ${index + 1}`} />
                            ))}
                            <a href={`/products/${product.handle}`}>See more</a>
                        </div>
                    )}
                </div>
            )}
            {(!isNonTransactional || showPriceshowPriceTransactional) &&
                <>
                    <p className="featuredProductsSlider__ourPrice">Our Price {getCurrencyValue(currency, product.fromPrice)}</p>
                    {product.oldPrice && <p className="featuredProductsSlider__regularPrice">Regular price {getCurrencyValue(currency, product.oldPrice)}</p>}
                    <div>
                        <div className="featuredProductsSlider__button">SHOP</div>
                    </div></>
            }
        </a>
    )
}

const ProductCardPortrait = ({ product, currency }) => {
    return (
        <a href={`products/${product.handle}`} className="flex-none itemSlider option2 ">
            <div className="image mb-1">
                <img src={product.images[0]} />
            </div>
            <div>
                <p className="featuredProductsSlider__title">{product.title}</p>
            </div>
            {(availabilityOptionsOnCard.typeOfMaterialEnabled || availabilityOptionsOnCard.optionsCarouselEnabled) && (
                <div className="FeaturedProduct__available-options">
                    {availabilityOptionsOnCard.typeOfMaterialEnabled && (
                        <div className="material-options">
                            {product.customfields.infabric === 'Yes' && <FabricType />}
                            {product.customfields.inleather === 'Yes' && <LeatherType />}
                            {product.customfields.inleather === 'Yes' && product.customfields.infabric === 'No' && (
                                <p>Available in Leather</p>
                            )}
                            {product.customfields.inleather === 'No' && product.customfields.infabric === 'Yes' && (
                                <p>Available in Fabric</p>
                            )}
                            {product.customfields.inleather === 'Yes' && product.customfields.infabric === 'Yes' && (
                                <p>Available in Leather and Fabric</p>
                            )}
                        </div>
                    )}
                    {availabilityOptionsOnCard.optionsCarouselEnabled && product.optionsPreviewImages && product.optionsPreviewImages.length > 0 && (
                        <div className="image-container">
                            {product.optionsPreviewImages.map((image, index) => (
                                <img className="ProductList__options-image" key={index} src={image} alt={`Option ${index + 1}`} />
                            ))}
                            <a href={`/products/${product.handle}`}>See more</a>
                        </div>
                    )}
                </div>
            )}
            {(!isNonTransactional || showPriceshowPriceTransactional) &&
                <>
                    <div className="mb-1">
                        <p className="featuredProductsSlider__ourPrice">Our Price {getCurrencyValue(currency, product.fromPrice)}</p>
                        {product.oldPrice && <p className="featuredProductsSlider__regularPrice">Regular price {getCurrencyValue(currency, product.oldPrice)}</p>}
                    </div>
                    <div>
                        <div className="featuredProductsSlider__button">SHOP</div>
                    </div>
                </>
            }
        </a>
    )
}

